import { ButtonField, ButtonGroup, ButtonGroupItem, InputField, Modal, ModalBody, ModalFooter, ModalHeader, TextareaField } from "@wk/components-react16"
import { useState } from "react";
import { Toast } from "../../../services";
import HttpService from "../../../config/http.service";
import { API_URL } from "../../../config/constants";
import { useDispatch } from "react-redux";
import { hideLoading, showLoading } from "../../../store/authReducer";


const AddGptAgent = ({ data }: any) => {
    const dispatch = useDispatch();
    const { isOpenAddEdit, setIsOpenAddEdit, selectedItem, getAgentList, agentList } = data;
    const defaultFormObj = {
        id: selectedItem.id ? selectedItem.id : null,
        name: selectedItem.name ? selectedItem.name : '',
        description: selectedItem.description ? selectedItem.description : ''

    };
    
    const [formField, setFormField] = useState(defaultFormObj);

     const handleUserRequest = (origin: string) => {
        if (origin === 'esc' || origin === 'header' || origin === 'footer') {
            setIsOpenAddEdit(false);
        }
    }

    const handleAddQuestion = async () => {
        if (!formField.name || !formField.name.trim()) {
            Toast('Please enter name', 'error');
            return;
        }
        if (!formField.description || !formField.description.trim()) {
            Toast('Please enter description', 'error');
            return;
        }
        
        if(agentList.some((agent: any) => agent.name === formField.name)) {
            Toast('FAB Agent with the same name already exists. Please enter a different name.', 'error');
            return;
        }

        dispatch(showLoading());
         HttpService.postRequest(API_URL.ADD_GPT_AGENT, formField).then(
            (res: any) => {
                Toast(selectedItem?.id ? "Fab Agent updated successfully." : "Fab Agent added successfully.", "success");
                getAgentList();
                setIsOpenAddEdit(false);
                dispatch(hideLoading());
            },
            (err: any) => {
                dispatch(hideLoading());
                Toast(err.message, "error")
            },
        )

    }

    const handleInputChange = (event: any) => {
        const { name, value } = event.target;
        setFormField({
            ...formField,
            [name]: value,
        });
    };
    
    return (
        <>
        <Modal
            isOpen={isOpenAddEdit}
            srLabelledBy={'modal-id-gptagent'}
            srDescribedBy={'modal-id-gptagent'}
            onUserRequest={handleUserRequest}>
            <ModalHeader
                titleId={'modal-id-gptagent'}
                isFullscreenButtonVisible={false}
                onUserRequest={() => handleUserRequest('header')}>
                {selectedItem?.id ? 'Edit FAB Agent' : 'Add FAB Agent'}
            </ModalHeader>
            <ModalBody descriptionId="modal-id-gptagent">
                <div className='wk-grid-page-container p-0'>
                    <div className='wk-row'>
                        <div className="wk-col-12">
                            <InputField label="Name" labelFor="name-input-1" size="small" indicator="required">
                                <input
                                    type="text" id="name-input-1" name="name"
                                    placeholder="Name"
                                    onChange={(event: any) => handleInputChange(event)}
                                    value={formField.name} autoComplete="off"
                                />
                            </InputField>
                            <TextareaField label="Description" indicator="required">
                                <textarea
                                    name="description"
                                    onChange={(event: any) => handleInputChange(event)}
                                    value={formField.description}
                                ></textarea>
                            </TextareaField>
                        </div>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <ButtonGroup mode="static">
                    <ButtonGroupItem slot="buttonGroupItem">
                        <ButtonField size={'small'} mode={'ghost'}>
                            <button type="button" className="mr-10"
                                onClick={() => handleUserRequest('footer')}>
                                Cancel
                            </button>
                        </ButtonField>
                        <ButtonField size={'small'}>
                            <button
                                type="button"
                                id="save"
                                onClick={handleAddQuestion}>
                                Save
                            </button>
                        </ButtonField>
                    </ButtonGroupItem>
                </ButtonGroup>
            </ModalFooter>
        </Modal>
        </>
    )
}

export default AddGptAgent;